export class Observable {
  constructor() {
    this.observers = [];
  }
  subscribe(subscriber) {
    this.observers.push(subscriber);
  }
  unsubscribe(id) {
    this.observers = this.observers.filter(obs => obs.id !== id);
  }
  async notify(data) {
    await Promise.allSettled(this.observers.map(observer => observer.callback(data)));
  }
}